var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSecurity = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.906 2.952v4.759a7.44 7.44 0 0 0 4.77 6.945l.65.25c.434.167.914.167 1.347 0l.65-.25a7.44 7.44 0 0 0 4.77-6.945V2.952a.93.93 0 0 0-.542-.851A13.6 13.6 0 0 0 8 .969 13.6 13.6 0 0 0 2.449 2.1a.93.93 0 0 0-.543.851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M8 9.406a.234.234 0 1 1 0-.469M8 9.406a.234.234 0 1 0 0-.469"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 7.531V4.72"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.906 2.952v4.759a7.44 7.44 0 0 0 4.77 6.945l.65.25c.434.167.914.167 1.347 0l.65-.25a7.44 7.44 0 0 0 4.77-6.945V2.952a.93.93 0 0 0-.542-.851A13.6 13.6 0 0 0 8 .969 13.6 13.6 0 0 0 2.449 2.1a.93.93 0 0 0-.543.851"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    d: "M8 9.406a.234.234 0 1 1 0-.469M8 9.406a.234.234 0 1 0 0-.469"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 7.531V4.72"
  }));
});
export default SvgIconSecurity;
export const raw = __webpack_public_path__ + "static/media/IconSecurity.76003f983eee68a8b29b33597553b04d.svg";